import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Link,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  TextField,
  Tooltip,
  IconButton,
  Autocomplete,
  Avatar
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { DataGrid } from '@mui/x-data-grid';
import { DropzoneArea } from 'mui-file-dropzone';
import { useForm } from 'react-hook-form';
import Page from 'src/components/Page';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import ordenService from 'src/services/ordenService';
import genService from 'src/services/generalServices';
import combosService from 'src/services/combosService';
import { useSearchParams } from 'react-router-dom';
import { DoubleArrow, Delete, Assignment } from '@mui/icons-material';
import { Download } from 'react-feather';
import renderCellExpand from 'src/views/commons/RenderCellExpand';
import ConfirmationDialog from 'src/views/commons/ConfirmationDialog';
import OrderGeneral from '../OrderCommons/OrderGeneral';
import AvisoPrivacidad from '../CargaDocumentos/AvisoPrivacidad';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    '& .MuiDataGrid-window': {
      bottom: 'auto'
    }
  },
  title: {
    fontSize: 16,
    marginBottom: theme.spacing(1),
    fontWeight: 500,
    letterSpacing: '-0.05px'
  },
  checkBoxVerde: {
    color: '#4caf50 !important'
  },
  dropZoneStyle: {
    minHeight: '10px',
  },
  cardAccent: {
    borderTop: `4px solid ${theme.palette.primary.main}`,
    boxShadow: theme.shadows[8]
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  }
}));

const Solicitudes = ({
  setOpenBackDrop,
  setServerError,
  setOpenSnackError,
  setServerMessage,
  setOpenSnackSuccess,
  setComboEstados,
  setComboMunicipios,
  mapaMunicipios,
  setMapaMunicipios,
  ...props
}) => {
  const {
    register,
    formState: { errors },
    setError,
    setValue,
    clearErrors,
    control,
    handleSubmit,
    reset,
    trigger
  } = useForm();
  const classes = useStyles();
  const [folio, setFolio] = useState();
  const [isLaboral, setIsLaboral] = useState(false);
  const [isEscuela, setIsEscuela] = useState(false);
  const [nombreCliente, setNombreCliente] = useState();
  const [idOrdenEstatus, setIdOrdenEstatus] = useState();
  const [idEstatusLiga, setIdEstatusLiga] = useState();
  const [comboGradoEscolar, setComboGradoEscolar] = useState([]);
  const [valGradoEscolar, setValGradoEscolar] = useState({});
  const [searchParams] = useSearchParams();
  const [errorLigaSolicitud, setErrorLigaSolicitud] = useState(null);
  const [openGenerar, setOpenGenerar] = useState(false);
  const [formData, setFormData] = useState({});
  const [idCliente, setIdCliente] = useState(0);
  const [aceptarAviso, setAceptarAviso] = useState(false);
  const [openAviso, setOpenAviso] = useState(false);
  const [openRejected, setOpenRejected] = useState(false);
  const [rowsRejected, setRowsRejected] = useState([]);
  const [rowsFiles, setRowsFiles] = useState([]);
  const [openEliminar, setOpenEliminar] = useState(false);
  const [fileTypes, setFilesTypes] = useState([]);
  const [deleteFileRow, setDeleteFileRow] = useState(null);
  const [docsRequired, setDocsRequired] = useState(false);

  useEffect(() => {
    setValue('aceptarAviso', aceptarAviso);
  }, [aceptarAviso]);

  const columnsRejected = [
    {
      field: 'fileName',
      headerName: 'Nombre del Archivo',
      minWidth: 200,
      flex: 1,
      renderCell: renderCellExpand,
      headerClassName: 'summary-header'
    },
    {
      field: 'rechazo',
      headerName: 'Razón de Rechazo',
      minWidth: 200,
      flex: 1,
      sortable: false,
      renderCell: renderCellExpand,
      headerClassName: 'summary-header'
    }
  ];

  const columnsFiles = [
    {
      field: 'tipoArchivo',
      headerName: 'Tipo de Archivo',
      minWidth: 200,
      flex: 1,
      sortable: false,
      renderCell: (rowParam) => {
        const { row } = rowParam;
        const defVal = fileTypes.findIndex((auxVal) => auxVal.value === row.idTipoArchivo);
        const rowIndex = rowParam.api.getAllRowIds().indexOf(rowParam.id);
        const nameComponent = `TipoArchivo_${rowIndex}`;
        return (
          <Autocomplete
            id={nameComponent}
            size="small"
            fullWidth
            options={fileTypes}
            defaultValue={fileTypes[defVal]}
            getOptionLabel={(option) => (option.label ? option.label : '')}
            renderInput={(params) => (
              <TextField
                {...params}
                {...register(nameComponent, {
                  required: { value: true, message: 'Campo requerido.' },
                  validate: () => {
                    console.log('Validando: ', rowParam);
                    const idTipoActual = rowParam.row.idTipoArchivo;
                    const esDuplicado = rowsFiles.some((typeF) => typeF.nombre
                      !== rowParam.row.nombre
                      && typeF.idTipoArchivo === rowParam.row.idTipoArchivo
                      && idTipoActual !== '');
                    return esDuplicado ? 'Este tipo de archivo ya fue seleccionado.' : true;
                  }
                })}
                error={!!errors[nameComponent]}
                helperText={errors[nameComponent]?.message}
                variant="outlined"
                placeholder="Tipo de Archivo"
              />
            )}
            style={{ lineHeight: '0px' }}
            onChange={(e, newValue) => {
              clearErrors(nameComponent);
              rowParam.row.tipoArchivo = newValue ? newValue.label : '';
              rowParam.row.idTipoArchivo = newValue ? newValue.value : '';
              const camposValidación = rowsFiles.map((_, index) => `TipoArchivo_${index}`);
              trigger(camposValidación);
            }}
          />
        );
      }
    },
    {
      field: 'nombre',
      headerName: 'Nombre de Archivo',
      minWidth: 150,
      flex: 1,
      renderCell: renderCellExpand
    },
    {
      field: 'comentarios',
      headerName: 'Comentarios',
      minWidth: 200,
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const { row } = params;
        return (
          <TextField
            fullWidth
            multiline
            placeholder="Ingrese máximo 150 caractéres"
            maxRows={2}
            defaultValue={row.comentarios}
            variant="standard"
            onInput={genService.toUpperCase}
            slotProps={{
              htmlInput: {
                style: { fontSize: 12, padding: 5 },
                maxLength: 150
              }
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
            onChange={(e) => {
              params.row.comentarios = e.target.value;
            }}
          />
        );
      }
    },
    {
      field: 'acciones',
      headerName: 'Acciones',
      maxWidth: 100,
      minWidth: 100,
      sortable: false,
      disableClickEventBubbling: true,
      align: 'center',
      renderCell: (params) => {
        const onClickDownload = () => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(params.row.archivo);
          link.download = params.row.nombre;
          link.click();
        };
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%'
            }}
          >
            <Tooltip title="Eliminar">
              <IconButton
                className={classes.customHoverFocus}
                onClick={() => {
                  setOpenEliminar(true);
                  setDeleteFileRow(params.row);
                }}
                fontSize="small"
                color="primary"
                size="large"
              >
                <Delete fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Descargar">
              <IconButton
                className={classes.customHoverFocus}
                onClick={onClickDownload}
                fontSize="small"
                color="primary"
                size="large"
              >
                <Download fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        );
      }
    }
  ];

  const resetForm = () => {
    reset();
    setErrorLigaSolicitud(null);
    setFormData({});
    setValGradoEscolar({});
  };

  const getComboGradoEscolar = (clienteId, idGradoEscolar) => {
    if (clienteId !== undefined && clienteId > 0) {
      combosService.comboGradoEscolar(clienteId).then((resp) => {
        setComboGradoEscolar(resp);
        if (idGradoEscolar !== undefined && idGradoEscolar > 0) {
          const selecGrado = resp.filter((aux) => aux.value === idGradoEscolar);
          setValGradoEscolar(selecGrado[0]);
        }
      });
    }
  };

  const getComboMunicipios = (newValue) => {
    setComboMunicipios([]);
    if (newValue !== null) {
      setValue('idMunicipio', '');
      combosService.addComboMunicipios(newValue, mapaMunicipios,
        setComboMunicipios, setMapaMunicipios);
    }
  };

  useEffect(() => {
    const urlKey = searchParams.get('key');
    const encodedURL = encodeURIComponent(urlKey);
    console.log('the Key', encodedURL);

    const getBaseOrder = async (key) => {
      setOpenBackDrop(true);
      setErrorLigaSolicitud(null);
      await ordenService.getBaseOrderByKey(key).then((resp) => {
        console.log('Base order resp:', resp);
        setFolio(ordenService.generarFolio());
        if (resp.data.tipoCliente === 'Laboral') {
          setIsLaboral(true);
        }
        if (resp.data.tipoCliente === 'Escuela') {
          setIsEscuela(true);
          getComboGradoEscolar(resp.data.idCliente, formData.idGradoEscolar);
        }
        combosService.comboEstados().then((respuesta) => {
          setComboEstados(respuesta);
        });
        const linksArchivos = [2];
        combosService.comboFileTypeLink(linksArchivos).then((respTipos) => {
          setFilesTypes(respTipos);
        });
        combosService.addComboMunicipios(9, mapaMunicipios,
          setComboMunicipios, setMapaMunicipios);
        setIdOrdenEstatus(resp.data.idOrdenEstatus);
        setIdEstatusLiga(resp.data.idEstatusLiga);
        setNombreCliente(resp.data.nombreCliente);
        setIdCliente(resp.data.idCliente);
        setDocsRequired(resp.data.docsLink);
      }).catch((error) => {
        if (error.response !== undefined) {
          setErrorLigaSolicitud(error.response.data.message);
        } else {
          setErrorLigaSolicitud(`${error.message}: No fue posible conectar con el servidor`);
        }
      });
      setOpenBackDrop(false);
    };

    getBaseOrder(encodedURL);
  }, []);

  const agregaArchivos = (fileList) => {
    let filesList = [];
    console.log('inside agregar archivos', fileList);
    const uploadFileToS3 = async (file) => {
      setOpenBackDrop(true);
      console.log('the length of files list:', fileList.length);
      if (filesList.length === 0) {
        filesList = rowsFiles.slice();
        console.log('the length of files list after slice:', fileList.length);
      }
      console.log('the file list', rowsFiles);
      const existingFile = filesList.findIndex((auxFile) => auxFile.nombre === file.name);
      const currentFile = rowsFiles.filter((auxFile) => auxFile.nombre === file.name);
      console.log('The current file', currentFile[0]);
      let nombreArchivo = file.name;
      const nombreSinExtension = nombreArchivo.substring(0, nombreArchivo.lastIndexOf('.'));
      if (nombreSinExtension.length > 50) {
        const extension = nombreArchivo.substring(nombreArchivo.lastIndexOf('.'), nombreArchivo.length);
        const nombreCorto = nombreSinExtension.substring(0, 50);
        console.log('Longitud del nombre', nombreArchivo.length);
        console.log('Extension del archivo', extension);
        console.log('nombreCorto', nombreCorto + extension);
        nombreArchivo = nombreCorto.trim() + extension;
        setOpenSnackError(true);
        setServerError('El nombre de alguno de sus archivos fue reducido a 50 caracteres.');
      }
      let uniqueId;
      if (currentFile && currentFile.length > 0) {
        console.log('inside current file', currentFile);
        uniqueId = currentFile[0].keyIndex;
      } else {
        console.log('new UUID');
        uniqueId = crypto.randomUUID();
      }
      const fileNewName = new File([file], `${uniqueId}<*>${ file.name }`, { type: file.type });
      console.log('adding new file name:', fileNewName);
      if (existingFile < 0) {
        const itemFile = {
          id: `${folio}_${nombreArchivo}`,
          nombre: nombreArchivo,
          size: file.size,
          fileBucketName: `CARGADOC_${folio}_${nombreArchivo}`,
          comentarios: '',
          estatus: 'NUEVO',
          tipoArchivo: '',
          idTipoArchivo: 0,
          archivo: fileNewName,
          enServidor: false,
          keyIndex: uniqueId
        };
        filesList.push(itemFile);
      } else {
        filesList[existingFile].archivo = fileNewName;
        filesList[existingFile].size = file.size;
        if (filesList[existingFile].estatus !== 'NUEVO') {
          filesList[existingFile].estatus = 'ACTUALIZADO';
        }
      }
      setOpenBackDrop(false);
    };

    fileList.forEach((file) => {
      uploadFileToS3(file);
    });
    if (filesList.length > 0) {
      setRowsFiles(filesList);
    }
  };

  const onClickRemove = async () => {
    setOpenBackDrop(true);
    setOpenEliminar(false);
    let nonSelectedRows = [];
    console.log('lista archivos', rowsFiles);
    console.log('archivo selec', deleteFileRow);
    if (deleteFileRow !== null) {
      nonSelectedRows = rowsFiles.filter((row) => row.id !== deleteFileRow.id);
    }
    setRowsFiles(nonSelectedRows);
    setDeleteFileRow(null);
    setOpenBackDrop(false);
  };

  const onSubmit = () => {
    const handleAsync = async (datos) => {
      console.log('Datos de la orden:', datos);
      setOpenBackDrop(true);
      await ordenService.altaOrdenExpress(datos).then((resp) => {
        setServerMessage(`La orden con folio ${resp.data.folio} fue creada correctamente.`);
        setOpenSnackSuccess(true);
        setFolio(ordenService.generarFolio());
        setRowsFiles([]);
        resetForm();
      }).catch((error) => {
        setOpenSnackError(true);
        if (error.response !== undefined) {
          setServerError(error.response.data.message);
        } else {
          setServerError(`${error.message}: No fue posible conectar con el servidor`);
        }
      }).finally(() => {
        setOpenBackDrop(false);
      });
      setOpenBackDrop(false);
    };
    formData.folio = folio;
    formData.matricula = isEscuela ? formData.matricula : '';
    formData.puesto = isLaboral ? formData.puesto : '';
    formData.idOrdenEstatus = idOrdenEstatus;
    formData.idEstatusLiga = idEstatusLiga;
    formData.idCliente = idCliente;
    formData.estadoLiga = 1;
    formData.idGradoEscolar = isEscuela ? (valGradoEscolar?.value || 0) : 0;
    formData.gradoEscolar = isEscuela && valGradoEscolar?.label ? valGradoEscolar : null;
    formData.direccion.id = 0;

    const archivoDTO = rowsFiles.map((auxFile) => {
      if (auxFile.estatus === 'NUEVO') {
        auxFile.id = 0;
      }

      return auxFile;
    });

    formData.archivos = archivoDTO;
    handleAsync(formData);
  };

  const confirmSubmit = (data) => {
    setOpenGenerar(true);
    setFormData(data);
  };

  return (
    <Page
      className={classes.root}
      title="Solicitud de Trabajo"
    >
      { errorLigaSolicitud
        ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              justifyContent: 'center'
            }}
          >
            <Container maxWidth="md">
              <Typography
                align="center"
                color="textPrimary"
                variant="h1"
              >
                {errorLigaSolicitud}
              </Typography>
              <Typography
                align="center"
                color="textPrimary"
                variant="subtitle2"
              >
                Hubo un error al tratar de cargar la página, por favor contacte con el
                administrador
              </Typography>
            </Container>
          </Box>
        ) : (
          <div className={clsx(classes.title)}>
            <Container maxWidth="lg">
              <Typography className={classes.title}>
                Solicitudes
              </Typography>
              <Card className={classes.cardAccent}>
                <CardHeader
                  avatar={(
                    <Avatar className={classes.avatar}>
                      <Assignment />
                    </Avatar>
                  )}
                  title={nombreCliente}
                />
                <Divider />
                <CardContent>
                  <form
                    id="orderForm"
                    onSubmit={handleSubmit(confirmSubmit)}
                  >
                    <OrderGeneral
                      register={register}
                      folio={folio}
                      errors={errors}
                      isLaboral={isLaboral}
                      isEscuela={isEscuela}
                      idOrden={0}
                      setValue={setValue}
                      setError={setError}
                      clearErrors={clearErrors}
                      control={control}
                      rolUsuario="NO_ROL"
                      valGradoEscolar={valGradoEscolar}
                      setValGradoEscolar={setValGradoEscolar}
                      comboGradoEscolar={comboGradoEscolar}
                      getComboGradoEscolar={getComboGradoEscolar}
                      getComboMunicipios={getComboMunicipios}
                      {...props}
                    />
                    {docsRequired
                      ? (
                        <Grid
                          container
                          spacing={3}
                          sx={{
                            justifyContent: 'center'
                          }}
                        >
                          <Grid
                            size={{
                              md: 8,
                              xs: 8
                            }}
                          >
                            <DropzoneArea
                              clearOnUnmount
                              dropzoneClass={classes.dropZoneStyle}
                              acceptedFiles={[
                                'application/pdf',
                                'image/png',
                                'image/jpeg'
                              ]}
                              onDrop={(file) => {
                                console.log('Total de archivos agregados ', rowsFiles.length);
                                console.log('Total de archivos a agregar ', file.length);
                                console.log('Files rejected ', rowsRejected.length);
                                if (rowsFiles.length === 2
                                  || (rowsFiles.length + file.length + rowsRejected.length) > 2) {
                                  setServerError('El número máximo de archivos por solicitud es 2.');
                                  setOpenSnackError(true);
                                  setOpenRejected(false);
                                } else {
                                  let cont = rowsRejected && rowsRejected.length > 0
                                    ? rowsRejected.length : 0;
                                  if (file && file.length > 0) {
                                    file = file.filter((fileItem) => {
                                      const nombreArchivo = fileItem.name;
                                      const nombreSinExtension = nombreArchivo.substring(0, nombreArchivo.lastIndexOf('.'));
                                      if (nombreSinExtension.length <= 50) {
                                        return true;
                                      }
                                      cont++;
                                      setRowsRejected((rowRejected) => [...rowRejected, {
                                        id: cont,
                                        fileName: fileItem.name,
                                        rechazo: `Este nombre de archivo tiene ${nombreSinExtension.length} caracteres, no puede ser mayor a 50`
                                      }]);
                                      return false;
                                    });
                                  }
                                  console.log('The rows rejected:', rowsRejected);
                                  if (cont > 0) {
                                    setOpenRejected(true);
                                  }
                                  if (file.length > 0) {
                                    agregaArchivos(file);
                                    setServerMessage(`Se caragaron ${file.length} archivo(s) correctamente.`);
                                    setOpenSnackSuccess(true);
                                  }
                                }
                              }}
                              filesLimit={500}
                              dropzoneText={(
                                <div>
                                  <div>Arrastre y suelte un archivo (Máximo 2 por solicitud).</div>
                                  <div style={{ fontWeight: '100', fontFamily: 'sans-serif', fontStyle: 'italic' }}>
                                    (Máx 3 MB y con extensiones: .jpg, .png y .pdf)
                                  </div>
                                  <div style={{ fontWeight: 'bold', fontFamily: 'sans-serif', fontStyle: 'italic' }}>
                                    (El nombre de los archivos no puede ser mayor a 50 caracteres)
                                  </div>
                                </div>
                              )}
                              maxFileSize={3200000}
                              showPreviewsInDropzone={false}
                              alertSnackbarProps={{ anchorOrigin: { vertical: 'bottom', horizontal: 'center' } }}
                              showAlerts={false}
                              onChange={() => {
                                if (!openRejected) {
                                  setRowsRejected([]);
                                }
                              }}
                              onDropRejected={(files) => {
                                console.log('Rejected on drop', files);
                                setRowsRejected([]);
                                if (rowsFiles.length === 2 || files.length > 2) {
                                  setServerError('El número máximo de archivos por solicitud es 2.');
                                  setOpenSnackError(true);
                                  setRowsRejected(files);
                                } else {
                                  let cont = 0;
                                  files.forEach((fileRej) => {
                                    let rechazoMsg = '';
                                    if (fileRej.size > 3200000) {
                                      rechazoMsg = `El tamaño del archivo es de ${fileRej.size / 1000000} 
                                        MB, no puede ser mayor a 3MB`;
                                    } else {
                                      rechazoMsg = 'El formato del archivo no esta permitido.';
                                    }
                                    setRowsRejected((rowRejected) => [...rowRejected, {
                                      id: cont++,
                                      fileName: fileRej.name,
                                      rechazo: rechazoMsg
                                    }]);
                                    console.log('arrays rejected', rowsRejected);
                                    if (rowsFiles.length === 0 && files.length <= 2) {
                                      setOpenRejected(true);
                                    }
                                  });
                                }
                              }}
                            />
                          </Grid>
                        </Grid>
                      ) : (
                        null
                      )}
                    <br />
                    <Grid
                      container
                      spacing={3}
                      style={{ display: rowsFiles.length > 0 ? '' : 'none' }}
                      sx={{
                        justifyContent: 'center'
                      }}
                    >
                      <Grid
                        align="center"
                        size={{
                          md: 12,
                          xs: 12,
                          sm: 12
                        }}
                      >
                        <DataGrid
                          rows={rowsFiles}
                          columns={columnsFiles}
                          autoHeight
                          disableColumnFilter
                          disableColumnMenu
                          hideFooter
                          disableRowSelectionOnClick
                          onRowSelectionModelChange={(selec) => {
                            console.log('La seleccion de archivo:', selec);
                            // setFileSelected(selec);
                          }}
                          style={{ bottom: 'auto' }}
                        />
                      </Grid>
                    </Grid>
                    <br />
                    <Divider />
                    <br />
                    <Grid
                      container
                      spacing={3}
                      sx={{
                        justifyContent: 'center'
                      }}
                    >
                      <Grid
                        align="center"
                        size={{
                          md: 12,
                          xs: 12,
                          sm: 12
                        }}
                      >
                        <FormControl required error={errors}>
                          <FormControlLabel
                            control={(
                              <Checkbox
                                className={classes.checkBoxVerde}
                                name="aceptarAviso"
                                slotProps={{
                                  input: {
                                    ref: register('aceptarAviso', {
                                      required: {
                                        value: true,
                                        message: 'Es necesario aceptar el aviso de privacidad'
                                      }
                                    }).ref
                                  }
                                }}
                                color="primary"
                                checked={aceptarAviso}
                                onClick={(e) => {
                                  if (e.target.checked) {
                                    clearErrors(['aceptarAviso']);
                                  }
                                }}
                              />
                            )}
                            onChange={(e) => setAceptarAviso(e.target.checked)}
                            label={(
                              <Typography
                                variant="h6"
                              >
                                {'He leído y acepto el aviso de privacidad -- '}
                                <Link
                                  variant="body2"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setOpenAviso(true);
                                  }}
                                >
                                  CONSULTAR
                                </Link>
                              </Typography>
                            )}
                          />
                          <FormHelperText>{errors.aceptarAviso?.message}</FormHelperText>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={3}
                      className={classes.paddingGrid}
                      sx={{
                        justifyContent: 'center'
                      }}
                    >
                      <Grid
                        align="center"
                        size={{
                          md: 12,
                          xs: 12
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          endIcon={<DoubleArrow />}
                          type="submit"
                        >
                          SOLICITAR
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </CardContent>
              </Card>
            </Container>
            <Dialog
              PaperProps={{
                style: {
                  width: '100%',
                  maxWidth: '100%'
                }
              }}
              disableEscapeKeyDown
              aria-labelledby="confirmation-dialog-title"
              open={openRejected}
            >
              <DialogTitle id="confirmation-dialog-title">
                Error en la Carga de Archivos
              </DialogTitle>
              <DialogContent dividers>
                <DataGrid
                  rows={rowsRejected}
                  columns={columnsRejected}
                  autoHeight
                  disableColumnFilter
                  disableColumnMenu
                  disableVirtualization
                  hideFooter
                  disableRowSelectionOnClick
                  style={{ bottom: 'auto' }}
                />
                <div style={{ fontWeight: 'bold', color: 'red' }}>* Favor de corregir los errores y volver a intentar la carga de los archivos.</div>
              </DialogContent>
              <DialogActions>
                <Button
                  form="cargaDocsForm"
                  type="submit"
                  color="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    setRowsRejected([]);
                    setOpenRejected(false);
                  }}
                >
                  ENTERADO
                </Button>
              </DialogActions>
            </Dialog>
            <ConfirmationDialog
              keepMounted
              open={openEliminar}
              onClose={() => {
                setOpenEliminar(false);
                setDeleteFileRow(null);
              }}
              confirm={onClickRemove}
              title="Eliminar archivos"
              message={deleteFileRow === null ? 'Seguro que desea eliminar los archivos seleccionados?' : 'Seguro que desea eliminar el archivo?'}
            />
            <ConfirmationDialog
              title="Generar solicitud"
              message={`Esta seguro que desea enviar la solicitud ${folio} ?`}
              open={openGenerar}
              onClose={() => setOpenGenerar(false)}
              confirm={() => {
                setOpenGenerar(false);
                onSubmit();
              }}
            />
            <AvisoPrivacidad
              openAviso={openAviso}
              setOpenAviso={setOpenAviso}
              setAceptarAviso={setAceptarAviso}
              clearErrors={clearErrors}
            />
          </div>
        )}
    </Page>
  );
};

Solicitudes.propTypes = {
  setOpenBackDrop: PropTypes.func,
  setServerError: PropTypes.func,
  setOpenSnackError: PropTypes.func,
  setOpenSnackSuccess: PropTypes.func,
  setServerMessage: PropTypes.func,
  setComboEstados: PropTypes.func,
  setComboMunicipios: PropTypes.func,
  mapaMunicipios: PropTypes.array,
  setMapaMunicipios: PropTypes.func
};

export default Solicitudes;
